<div class="address-select">
  <div class="address-select__header header">
    <div class="header__label">
      @if (icon()) {
        <i class="icon" [ngClass]="[icon()]"></i>
      }

      <span class="header__label_name">{{ label() }}</span>
    </div>

    <span class="header__label_description">0.3 mi</span>
  </div>

  <div class="address-select__content">
    <ul class="address-select__content_address-list address-list">
      @for (address of addresses(); track $index) {
        <li class="address-list__item address">
          <label class="address__label">
            <span class="address__label_control">
              <input
                type="radio"
                name="pickup"
                [checked]="selectedAddressIndex() === $index"
                (change)="onAddressClick($index)"
              />
            </span>

            <span class="address__label_location location">
              <span class="location__name">{{ address.label }}</span>
              <button
                class="location__instruction"
                (click)="openGoogleMapsLocation(address.label || '')"
              >
                <span class="location__instruction_label">
                  Get Driving Instructions
                </span>
                <i class="icon icon-arrow-top-right"></i>
              </button>
            </span>
          </label>
        </li>
      } @empty {
        <li class="address-list__item address empty">No addresses found.</li>
      }
    </ul>
  </div>
</div>
